export interface FaqItem {
  id: string;
  q: string;
  a: string;
}

export interface FaqGroup {
  id: string;
  title: string;
  desc: string;
  items: FaqItem[];
}

export const FAQ_GROUPS: FaqGroup[] = [
  {
    id: 'g1',
    title: '赛程与时间',
    desc: '关于阶段划分、起止时间和时间变更的说明。',
    items: [
      {
        id: 'q1',
        q: '爆料大赛的整体赛程一共分几个阶段？',
        a: '整个赛事分为七个阶段：报名与海选征集、资格初审、初赛公开投票、复赛评审、半决赛晋级、决赛冲刺、结果公示与颁奖。每个阶段的起止时间和产出物都写在赛程时间表页面，按顺序推进即可。',
      },
      {
        id: 'q2',
        q: '每个阶段大约持续多久，中间会不会突然缩短？',
        a: '海选征集阶段约 20 天，初赛公投约 15 天，复赛与决赛各约 15 至 12 天。除不可抗力外不会缩短已公布的阶段时长；确需调整时会提前在官网公告区发布变更说明，并同步更新时间表。',
      },
      {
        id: 'q3',
        q: '时间表里标注的时间是北京时间吗？',
        a: '是的，页面所有时间均以北京时间（UTC+8）为准的最后时刻计算。跨时区参赛的选手请自行换算，建议提前一天完成提交，避免因为时差错过节点。',
      },
      {
        id: 'q4',
        q: '海选截稿之后还能不能补交或替换作品？',
        a: '不能。9 月 20 日 24:00 通道关闭后不再接收任何新提交，也不支持替换已发布的作品。截稿前可以随时修改，系统以关闭时刻的版本作为最终版本。',
      },
    ],
  },
  {
    id: 'g2',
    title: '报名与投稿',
    desc: '关于报名资格、提交内容与材料规范的常见疑问。',
    items: [
      {
        id: 'q5',
        q: '参加爆料大赛需要什么资格？',
        a: '年满 18 周岁、能够独立完成内容创作的个人均可报名，不限制职业和地域。同一账号最多提交 3 份作品，团队参赛以主创账号为准，团队人数不超过 5 人。',
      },
      {
        id: 'q6',
        q: '作品必须是首发吗，旧内容能不能改一改再投？',
        a: '提交作品应为原创且未在公开平台完整发布过。已经发布过的旧内容可以重新整理、补充信息后投稿，但需要在报名时说明原始来源，重复度高的搬运内容会在资格初审阶段被剔除。',
      },
      {
        id: 'q7',
        q: '提交后才发现材料不完整怎么办？',
        a: '资格初审阶段如果发现材料缺失，组委会会通过站内信通知补正，补正窗口为收到通知后的 48 小时。逾期未补正的视为放弃，不再进入初赛投票。',
      },
    ],
  },
  {
    id: 'g3',
    title: '投票与评审',
    desc: '关于投票权重、刷票处理与评审打分的规则。',
    items: [
      {
        id: 'q8',
        q: '公众投票在总成绩里占多大比重？',
        a: '初赛阶段公众投票占 40%、评审打分占 60%，取加权后的合成成绩决定是否晋级。决赛阶段比例调整为公众投票 35%、终审打分 65%，避免单纯靠拉票决定名次。',
      },
      {
        id: 'q9',
        q: '每天可以投几票，会出现刷票吗？',
        a: '每个账号每日可投 3 票，同一作品每日限 1 票。系统会对异常增长做实时监测，确认刷票的作品票数将被清零并取消评奖资格，处理结果会在进度页公示。',
      },
      {
        id: 'q10',
        q: '评审团是怎么组成的，打分是否公开？',
        a: '评审团由 48 位内容行业从业者组成，复赛阶段随机分为 8 组交叉打分，去掉一个最高分和一个最低分后取平均。评审打分不逐个公开，但每位评委的打分区间会在赛后以汇总形式公布。',
      },
    ],
  },
  {
    id: 'g4',
    title: '结果与奖励',
    desc: '关于名单公示、申诉渠道与奖奖项发放的安排。',
    items: [
      {
        id: 'q11',
        q: '获奖名单什么时候公示，公示持续多久？',
        a: '11 月 21 日进入结果公示阶段，获奖名单与各奖项归属连续公示五个工作日，至 11 月 25 日结束。公示期内如有异议可通过站内申诉通道提交实名材料。',
      },
      {
        id: 'q12',
        q: '对结果有异议怎么申诉？',
        a: '在公示期内提交实名申诉，需附上作品编号、异议理由与可核验的证据材料。组委会在收到后三个工作日内给出书面答复，逾期或匿名提交的申诉不予受理。',
      },
      {
        id: 'q13',
        q: '单项奖的奖金和扶持名额怎么发放？',
        a: '金奖、银奖、铜奖与三个单项奖的奖金在颁奖盛典后 15 个工作日内发放，扶持名额与工作坊席位会由工作人员单独联系对接，具体安排以站内信通知为准。',
      },
    ],
  },
];